import { Stack, Typography, useTheme } from "@mui/material";
import { CopyIcon } from "components";
import { useGlobalStore } from "controller";
import { useMemo } from "react";
import toast from "react-hot-toast";

export const CopySupportMail = ({ email }: { email: string }) => {
  const theme = useTheme();

  const copyValue = () => {
    navigator.clipboard.writeText(email);
    toast.success("Copied to clipboard");
  };

  const { support, id, domain } = useMemo(() => {
    const [support = "", rest = ""] = email.split("@");
    const [id, ...domainParts] = rest.split(".");
    return {
      support,
      id,
      domain: "." + domainParts.join("."),
    };
  }, [email]);

  if (!email) {
    return <></>;
  }

  return (
    <Stack direction="row" alignItems={"center"} gap="8px">
      <Typography
        variant="body-small"
        border={`1px solid ${theme.palette.neutral["015"]}`}
        bgcolor={theme.palette.neutral["005"]}
        borderRadius={"4px"}
        p="12px 24px"
      >
        {support}
      </Typography>
      <Typography variant="body-small">@</Typography>
      <Typography
        variant="body-small"
        border={`1px solid ${theme.palette.neutral["015"]}`}
        bgcolor={theme.palette.neutral["005"]}
        borderRadius={"4px"}
        p="12px 24px"
        sx={{
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          height: "42px",
          overflow: "hidden",
          flex: 1,
        }}
      >
        {id}
      </Typography>
      <Stack direction={"row"} alignItems={"center"} gap="16px">
        <Typography variant="body-small">{domain}</Typography>
        <CopyIcon
          sx={{
            cursor: "pointer",
          }}
          color="action"
          onClick={copyValue}
        />
      </Stack>
    </Stack>
  );
};
